"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const constants_1 = __importStar(require("../utils/constants"));
const _base_1 = require("./_base");
/**
 * ![HomeIcon](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDE2LjUgMTYuMjUiPgogIDxkZWZzPgogICAgPHN0eWxlPgogICAgICAuY2xzLTEgewogICAgICAgIGZpbGw6ICNmZmY7CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgPC9kZWZzPgogIDx0aXRsZT5Ib21lPC90aXRsZT4KICA8ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIj4KICAgIDxnIGlkPSJMYXllcl8xLTIiIGRhdGEtbmFtZT0iTGF5ZXIgMSI+CiAgICAgIDxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTE2LjIxLDUuODUsOS4wNS4zYTEuMjIsMS4yMiwwLDAsMC0xLjU3LDBMLjI5LDUuODVBLjc0Ljc0LDAsMCwwLC4xNiw2LjlhLjcyLjcyLDAsMCwwLC41OS4yOUEuNzkuNzksMCwwLDAsMS4yMSw3bC41Ny0uNDV2OC42OGExLDEsMCwwLDAsMSwxSDEzLjcyYTEsMSwwLDAsMCwxLTFWNi41OWwuNTcuNDRhLjc1Ljc1LDAsMCwwLC45Mi0xLjE4Wm0tMi40OSw5LjQtMTAuOTQsMFY1LjgyTDguMjUsMS41N2w1LjQ3LDQuMjRaIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K)
 */
exports.HomeIcon = (_a) => {
    var { size = 18, color } = _a, props = __rest(_a, ["size", "color"]);
    const iconColor = constants_1.expandColor(constants_1.default, color) || "currentColor";
    return (React.createElement(_base_1.Svg, Object.assign({ viewBox: "0 0 16.5 16.25", fill: iconColor, width: size, height: size, size: size, role: props.onClick ? "button" : undefined, tabIndex: props.onClick ? 0 : undefined }, props),
        React.createElement("path", { d: "M16.21 5.85L9.05.3a1.22 1.22 0 0 0-1.57 0L.29 5.85A.74.74 0 0 0 .16 6.9a.72.72 0 0 0 .59.29.79.79 0 0 0 .46-.19l.57-.45v8.68a1 1 0 0 0 1 1h10.94a1 1 0 0 0 1-1V6.59l.57.44a.75.75 0 0 0 .92-1.18zm-2.49 9.4H2.78V5.82l5.47-4.25 5.47 4.24z" })));
};
//# sourceMappingURL=Icon.Home.js.map